<h2>Medication List</h2>
<div class="divider"></div>
<ol class="list-text">
    <li *ngFor="let drug of drugNames">{{ drug }}</li>
</ol>
<div class="text-end mt-3">
    <button class="btn btn-outline-primary" (click)="close()" mat-dialog-close [disabled]="isCancelDisabled">
        Cancel
    </button>
</div>